export default "__VITE_ASSET__HSSibZd___"